import DTO from '@/dataAccess/dto/DTO'

export default class ReportInfo extends DTO {
  static get url() {
    return 'reports/'
  }

  readonly name: string
  readonly code: string
  readonly category: string
  readonly formats: string[]
  readonly params: Record<string, FieldInfo>

  constructor({ name, code, category, params, formats }) {
    super()
    this.name = name
    this.code = code
    this.category = category
    this.params = params
    this.formats = formats
  }

  /**
   * Construct object with report params (input fields) as key,
   * used for report params form data binding.
   */
  get defaultData() {
    const result = {}
    for (const key of Object.keys(this.params)) {
      result[key] = null
    }
    return result
  }
}

class FieldInfo {
  constructor(readonly type: string, readonly label: string) {}
}
